import { CallRefinementServerStatus } from './enums/self-serve/call-refinement-server-status.enum';
import { CallRefinementStatus } from './enums/self-serve/call-refinement-status.enum';
import { SimulationGenerationStatus } from './enums/self-serve/simulation-generation-status.enum';

/** Maps a raw server status (and optional failure reason) for a refinement
 * workflow to one of the generic UI states. An unrecognized status (e.g. a
 * future intermediate stage the frontend doesn't know about yet) falls back
 * to Thinking rather than Idle or Error, since staying in a "still working"
 * state is the safer default than implying nothing is happening or falsely
 * alarming the user.
 *
 * `reason` is only present on REFINEMENT_FAILED events delivered via SSE —
 * the polling fallback never carries it, so callers that only poll always
 * resolve failures to Error rather than OutOfScope. */
export function mapServerStatusToCallRefinementStatus(
  serverStatus: string | undefined,
  reason?: string,
): CallRefinementStatus {
  if (!serverStatus) return CallRefinementStatus.Idle;
  if (
    serverStatus === CallRefinementServerStatus.Completed ||
    serverStatus === SimulationGenerationStatus.Completed
  ) return CallRefinementStatus.Updated;
  if (serverStatus === CallRefinementServerStatus.Failed) {
    return reason === 'OUT_OF_SCOPE' ? CallRefinementStatus.OutOfScope : CallRefinementStatus.Error;
  }
  return CallRefinementStatus.Thinking;
}

export function isTerminalCallRefinementServerStatus(serverStatus: string | undefined): boolean {
  return (
    !!serverStatus &&
    (serverStatus === CallRefinementServerStatus.Completed ||
      serverStatus === CallRefinementServerStatus.Failed ||
      serverStatus === SimulationGenerationStatus.Completed)
  );
}
